import { render, staticRenderFns } from "./CbTransactionDatatable.vue?vue&type=template&id=6366bf1e&"
import script from "./CbTransactionDatatable.vue?vue&type=script&lang=js&"
export * from "./CbTransactionDatatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports